import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center overflow-hidden bg-navy" data-id="element-39">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/kUkdV8uesV3RoTWrJhx44t/renta_pagada.png')"
    }} data-id="element-40" />
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-navy/95 via-navy/80 to-navy/30 md:to-transparent" data-id="element-41" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-20 md:py-28" data-id="element-42">
        <div className="max-w-2xl" data-id="element-43">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-44">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-medium mb-8" data-id="element-45">
              <span className="animate-pulse" data-id="element-46">🔥</span> Oferta por tiempo
              limitado
            </div>

            {/* Headline */}
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight mb-6" data-id="element-47">
              Renta Pagada, Deuda Cero y Efectivo en el Bolsillo en 30 Días
            </h1>

            {/* Subheadline */}
            <p className="font-sans text-lg md:text-xl text-white/90 mb-10 leading-relaxed max-w-xl" data-id="element-48">
              Domina tu mes y recupera el control de tu bolsillo hoy por menos
              de lo que cuesta un café.
            </p>

            {/* CTA Area */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6" data-id="element-49">
              <motion.a href="https://protocolzenith.com/products/renta-pagada-y-deuda-cero-en-30-dias" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-lg font-bold shadow-[0_0_20px_rgba(16,185,129,0.3)] transition-colors duration-200" data-id="element-50">
                ¡SÍ, QUIERO EL PROTOCOLO POR SOLO $6.39! 🚀
              </motion.a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-4 text-sm text-white/70 font-sans" data-id="element-51">
              <div className="flex items-center gap-1.5" data-id="element-52">
                <LockIcon className="w-4 h-4" data-id="element-53" />
                <span data-id="element-54">Pago seguro</span>
              </div>
              <span className="hidden sm:inline opacity-50" data-id="element-55">•</span>
              <div className="flex items-center gap-1.5" data-id="element-56">
                <ZapIcon className="w-4 h-4" data-id="element-57" />
                <span data-id="element-58">Acceso inmediato</span>
              </div>
              <span className="hidden sm:inline opacity-50" data-id="element-59">•</span>
              <div className="flex items-center gap-1.5" data-id="element-60">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-61" />
                <span data-id="element-62">Garantía 7 días</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}